import React from "react";
import { CSSTransition } from "react-transition-group";
import styled, { css } from "styled-components";
import Text from "../base/Text";

const FloatingInputWrapper = styled.div`
  font-family: "pf_handbook_proregular";
  width: 100%;
  /* Initial Reset of Styles START */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  /* Chrome, Safari, Edge, Opera, Firefox */
  input[type="date"]::-webkit-calendar-picker-indicator {
    margin-right: 5px;
    padding: 0px 0.25em;
    height: 1em;
    background-image: "${(props) => props.dateIcon}";
    color: #cb3443;
  }
  /* Initial Reset of Styles END */

  /* Base Component Styles START */
  transition: margin-bottom 0.1s linear;
  width: 100%;
  /* Base Component Styles END */

  /* Floating FloatingInput */
  .floating-input {
    font-weight: 400;
    font-size: 18px;
    position: relative;
    margin-top: 13px;
    height: unset;
    input {
      border: 1.5px solid #e9e9e9; /* var(--color-input-border); */
      border-radius: 0.5em;
      padding: 0.15em 0em;
      width: 100%;
      font-size: 18px;
      color: var(--color-bw_americansilver);
      outline: none;
      background-color: #ffffff; /* var(--color-input-bg); */
      transition: all 0.1s ease;
    }
    label {
      position: absolute;
      content: "${(props) => props.label}";
      width: max-content;
      left: 0.3em;
      top: 50%;
      padding: 0em 0.3em;
      transform: translateY(-50%);
      color: #717171; // var(--color-bw_black);
      border: none;
      border-radius: 2px;
      font-size: 18px;
      pointer-events: none;
      transition: all 0.3s ease;
    }
    .suffixIcon {
      position: absolute;
      display: flex;
      column-gap: 5px;
      margin-right: -5px;
      width: max-content;
      right: 0.75em;
      top: 50%;
      padding: 0px 0.25em;
      transform: translateY(-50%);
      color: #717171; // var(--color-bw_black);
      border: none;
      border-radius: 2px;
      font-size: 18px;
      pointer-events: none;
    }
    .suffixIcon::after {
      content: "${(props) => props.suffixContent}";
      font-family: "pf_handbook_proregular";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: right;
      color: #575757;
      transition: all 0.3s ease;
      overflow: clip;
    }
    input:focus ~ .suffixIcon::after {
      width: 0;
      opacity: 0;
      margin: 0;
      padding: 0;
      margin-right: -10px;
    }
    input::placeholder {
      color: "transparent";
      ${"" /* color: var(--color-input-border); */}
    }

    input:focus,
    input:valid {
      border-color: transparent;
      border-bottom: 2px solid #e9e9e9; // var(--color-input-border);
      border-radius: 0.2em;
      transition: all 0.1s ease;
      color: #717171; // var(--color-bw_black);
    }
    input:focus ~ label,
    input:valid ~ label {
      top: -0.5em;
      left: 0.25em;
      font-size: 18px;
    }
    input:invalid ~ label {
      top: -0.5em;
      left: 0.25em;
      font-size: 18px;
    }
  }

  #arrowIcon {
    position: absolute;
    top: 10px;
    border: 3px solid #545454;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }

  .arrowIconUp {
    transform: rotate(-135deg) !important;
    -webkit-transform: rotate(-135deg) !important;
  }

  .arrowIconDown {
    transform: rotate(45deg) !important;
    -webkit-transform: rotate(45deg) !important;
  }

  /* Disabled State START*/
  ${(props) =>
    props.disabled === true &&
    css`
      .floating-input {
        input {
          border: 1.5px solid #e9e9e9; /* var(--color-input-border); */
          background-color: #e9e9e9; /* var(--color-input-bg); */
          color: var(--color-input-border);
          pointer-events: none;
        }
        label {
          color: grey;
          background-color: var(--color-bw_white);
        }
        input::placeholder {
          color: transparent;
        }
        ${props.value ? `input:disabled,` : ``}
        input:focus, input:valid {
          border-color: transparent;
          border-bottom: 2px solid var(--color-input-border);
          border-radius: 0.2em;
          transition: all 0.1s ease;
          color: ${() => /(iPhone|iPod|iPad)/i.test(navigator.userAgent) ? "black" : ""};
        }
        input:disabled ~ label,
        input:focus ~ label,
        input:valid ~ label {
          top: ${props.value ? `-0.5em` : `50%`};
          // left: ${props.value ? `0.25em` : `0.75em`};
          left: 0.3em;
          // font-size: ${props.value ? `0.7em` : `1em`};
          font-size: 18px;
        }
      }
    `};
  /* Disabled State END */

  /* Info, Error & Verification Messages START */
  .message-container {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    align-content: center;
    column-gap: 0.1em;
  }
  /* Messages Animation START */
  .msg-animation-container {
    position: relative;
    // font-size: 2px;
  }
  .msg {
    position: relative;
  }
  .msg-animation-enter {
    opacity: 0;
    top: -0.5em;
  }
  .msg-animation-enter-done {
    display: inline;
    opacity: 1;
    top: 0.15em;
    transition: all 0.15s linear;
  }
  .msg-animation-enter-done {
    opacity: 1;
    top: 0.15em;
    transition: all 0.15s linear;
    font-size: medium;
  }
  .msg-animation-exit {
    opacity: 1;
    top: 0px;
    transition: all 0.15s linear;
  }
  .msg-animation-exit-active {
    position: absolute;
    opacity: 0;
    top: 0px;
    transition: all 0.15s linear;
  }

  /* Messages Animation END */

  /* Error Message START */
  ${(props) =>
    props.error &&
    !props.disabled &&
    css`
      .floating-input {
        input {
          border-color: var(--color-support_goldengatebridge);
          transition: 0.1s linear;
        }
      }
    `};
  /* Error Message END */

  ${(props) =>
    props.error === true &&
    css`
      .floating-input {
        input {
          border: 1.5px solid #a52a2a;
          background-color: #e6cecc;
        }

        label {
          color: #a52a2a;
        }

        input:focus,
        input:valid {
          border-bottom: 2px solid #a52a2a;
          color: var(--color-bw_black);
        }
      }
    `};


  /* Verified Message START */
  ${(props) =>
    props.verified &&
    !props.disabled &&
    css`
      .floating-input {
        input {
          border-color: var(--color-support_salem);
          transition: 0.1s linear;
        }
      }
      .message {
        color: var(--color-support_salem);
      }
    `};

  /* Verified Message END */
  /* Info, Error & Verification Messages END */

  @media screen and (max-width: 920px) {
    font-family: "pf_handbook_proregular";
    font-weight: 400;
    font-size: 18px;
    .floating-input {
      input {
        font-size: 18px;
        padding: 0.1em 0.5em;
        color: #717171;
      }
      label {
        font-size: 18px;
      }
      input:focus ~ label {
        font-size: 18px;
      }
      input:valid ~ label {
        // top: -0.5em;
        font-size: 18px;
      }
    }
  }
  input[type="date"]::-webkit-datetime-edit {
    visibility: hidden;
  }
  input[type="date"]::-webkit-datetime-edit,
  input[type="date"]:focus::-webkit-datetime-edit {
    visibility: visible;
  }
  input::-webkit-date-and-time-value{ text-align:left; }
  input[type="date"] {
    display:block;
    // -webkit-appearance: textfield;
    -webkit-appearance: ${() => /(iPhone|iPod|iPad)/i.test(navigator.userAgent) ? "textfield" : ""};
    -moz-appearance: textfield;
    min-height: 1.2em;
    min-width: -webkit-fill-available;
    text-align: left;
    padding-left: ${(props) => props.inputPaddingLeft}px;
    color: #717171; // var(--color-bw_black);
  }
  input[type="date"]:focus,
  input[type="date"]:valid {
    padding: 0.15em 0.3em;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    display: block;
    background: "${(props) => props.dateIcon}";
  }
  ${(props) => (props.visible ? `` : `display: none;`)};

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #ffffff; /* var(--color-input-bg); */
    border: 1px solid #e9e9e9; /* var(--color-input-border); */
    width: 100%;
    max-width: inherit;
    overflow: auto;
    z-index: 1;
    max-height: 500%;
    border-radius: 0.5em;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding: 0.15em 0.5em;
    font-size: 18px;
    color: var(--color-bw_americansilver);
  }

  .dropdown-content .content {
    color: var(--color-bw_americansilver);
    padding: 10px;
    text-decoration: none;
    display: block;
  }

  .dropdown-content .content:hover {
    background-color: #ffffff;
    cursor: pointer;
  }

  .show {
    display: block;
  }
`;

const showDropdown = () => {
  changeArrowIcon();
  // var dropList = document.getElementById("myDropdown").classList;
  // // console.log("before: ", dropList);
  // dropList.toggle("show");
  // // console.log("after: ", dropList);
};

const changeArrowIcon = () => {
  var dropList = document.getElementById("myDropdown").classList;
  // var arrowList = document.getElementById("arrowIcon").classList;
  // // // console.log("before: ", arrowList);
  // // // console.log("before-1: ", dropList);
  // if (arrowList.contains("arrowIconUp")) {
  //   arrowList.remove("arrowIconUp");
  //   arrowList.add("arrowIconDown");
  // } else {
  //   arrowList.remove("arrowIconDown");
  //   arrowList.add("arrowIconUp");
  // }
  if (dropList.contains("show")) {
    setTimeout(() => {
      dropList.remove("show");
    }, 100);
  } else {
    dropList.add("show");
  }
  document.getElementById("myDropdown").classList = dropList;
  // document.getElementById("arrowIcon").classList = arrowList;
  // // console.log("after: ", arrowList);
  // // console.log("after-1: ", dropList);
};

const showDropdownGST = () => {
  changeArrowIconGST();
};

const changeArrowIconGST = () => {
  var dropList = document.getElementById("myDropdownGST").classList;
  if (dropList.contains("show")) {
    setTimeout(() => {
      dropList.remove("show");
    }, 100);
  } else {
    dropList.add("show");
  }
  document.getElementById("myDropdownGST").classList = dropList;
};

const showDropdownDOC = () => {
  changeArrowIconDOC();
};

const changeArrowIconDOC = () => {
  var dropList = document.getElementById("myDropdownDOC").classList;
  if (dropList.contains("show")) {
    setTimeout(() => {
      dropList.remove("show");
    }, 100);
  } else {
    dropList.add("show");
  }
  document.getElementById("myDropdownDOC").classList = dropList;
};

const filterFunction = () => {
  var input, filterText, ul, li, div, i, content;
  input = document.getElementById("input");
  var text = input.value !== undefined ? input.value : "";
  filterText = text.toUpperCase();
  div = document.getElementById("myDropdown");
  content = div.getElementsByClassName("content");
  for (i = 0; i < content.length; i++) {
    var txtValue = content[i].textContent || content[i].innerText;
    if (txtValue?.toUpperCase().indexOf(filterText) > -1) {
      content[i].style.display = "";
    } else {
      content[i].style.display = "none";
    }
  }
};

const FloatingInput2 = ({
  class_name = "",
  cursor_position = "",
  custom_styles = undefined,
  custom_styles_input = undefined,
  custom_styles_label = undefined,
  disabled = false,
  error = false,
  error_message = "Error",
  id = "input",
  info = false,
  info_message = "",
  left_label = "L",
  on_blur = undefined,
  on_focus = undefined,
  on_change = undefined,
  right_label = "R",
  label = "",
  placeholder = "",
  type = "text",
  value = "",
  verified = false,
  verified_message = "Verified",
  visible = true,
  list = undefined,
  suffixIcon = undefined,
  dateIcon = undefined,
  inputPaddingLeft = undefined,
  suffixContent = undefined,
  // onKeyUp = filterFunction,
  options = undefined,
  optionsGST = undefined,
  optionsDOC = undefined,
}) => {
  /*
        Method to keep cursor always at the end of the FloatingInput Text.
        Method fired conditionally for cursor_position props with onSelect handler.
    */
  const moveCursorToEnd = (e) => {
    e.target.selectionStart = e.target.selectionEnd = e.target.value.length;
  };

  /*
        Method to keep cursor always at the start of the FloatingInput Text.
        Method fired conditionally for cursor_position props with onSelect handler.
    */
  const moveCursorToStart = (e) => {
    e.target.selectionStart = e.target.selectionEnd = 0;
  };

  const optionsList = () => {
    var listOptions = [];
    for (var i = 0; i < options.length; ++i) {
      var element = (
        <div
          class="content"
          onClick={options[i]["func"]}
          key={i}
          value={options[i]["value"]}
        >
          {options[i]["label"]}
        </div>
      );
      listOptions.push(element);
    }
    var filterOptions = [];
    filterOptions.push(
      <>
        <div id="myDropdown" class="dropdown-content">
          {listOptions}
        </div>
      </>
    );
    return filterOptions;
  };

  const optionsListGST = () => {
    var listOptions = [];
    for (var i = 0; i < optionsGST.length; ++i) {
      var element = (
        <div
          class="content"
          onClick={optionsGST[i]["func"]}
          key={i}
          value={optionsGST[i]["value"]}
        >
          {optionsGST[i]["label"]}
        </div>
      );
      listOptions.push(element);
    }
    var filterOptions = [];
    filterOptions.push(
      <>
        <div id="myDropdownGST" class="dropdown-content">
          {listOptions}
        </div>
      </>
    );
    return filterOptions;
  };

  const optionsListDOC = () => {
    var listOptions = [];
    for (var i = 0; i < optionsDOC.length; ++i) {
      var element = (
        <div
          class="content"
          onClick={optionsDOC[i]["func"]}
          key={i}
          value={optionsDOC[i]["value"]}
        >
          {optionsDOC[i]["label"]}
        </div>
      );
      listOptions.push(element);
    }
    var filterOptions = [];
    filterOptions.push(
      <>
        <div id="myDropdownDOC" class="dropdown-content">
          {listOptions}
        </div>
      </>
    );
    return filterOptions;
  };

  const onFocus = options ? showDropdown : optionsGST ? showDropdownGST : optionsDOC ? showDropdownDOC : on_focus;
  const onBlur = options ? changeArrowIcon : optionsGST ? changeArrowIconGST : optionsDOC ? changeArrowIconDOC : on_blur;

  return (
    <>
      <FloatingInputWrapper
        className={class_name}
        disabled={disabled}
        error={error}
        errorMessage={error_message}
        placeholder={placeholder}
        id={id}
        info={info}
        infoMessage={info_message}
        leftLabel={left_label}
        rightLabel={right_label}
        styles={custom_styles}
        label={label}
        verified={verified}
        verifiedMessage={verified_message}
        value={value}
        inputType={type}

        visible={visible}
        suffixIcon={suffixIcon}
        suffixContent={suffixContent}
        dateIcon={dateIcon}
        inputPaddingLeft={inputPaddingLeft}
      >
        {/* Floating FloatingInput START */}
        <div className="floating-input">
          {/* ----- NOTE -----
                    Don't add 'defaultValue' prop here.
                    Ref: https://reactjs.org/docs/forms.html#controlled-components
                */}
          <input
            id={id}
            className={class_name}
            disabled={disabled}
            placeholder={placeholder}
            name={label}
            autoComplete="off"
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={on_change}
            required
            styles={custom_styles_input}
            inputMode={
              type === "Number" ? "numeric" : type === "email" ? "email" : "text"
            }
            type={type}
            value={value}
            onSelect={
              cursor_position === "end"
                ? (e) => {
                  moveCursorToEnd(e);
                }
                : cursor_position === "start"
                  ? (e) => {
                    moveCursorToStart(e);
                  }
                  : undefined
            }
          />
          <label styles={custom_styles_label}>{label}</label>
          {suffixIcon ? (
            <>
              <div
                style={{ pointerEvents: "auto" }}
                className="suffixIcon"
              >
                {suffixIcon}
              </div>
            </>
          ) : (
            <></>
          )}
          {options ? optionsList() : <></>}
          {optionsGST ? optionsListGST() : <></>}
          {optionsDOC ? optionsListDOC() : <></>}
        </div>
        {/* Floating FloatingInput END */}

        {/* Messages START */}

        {/* Messages END */}
      </FloatingInputWrapper>
      <div className="msg-animation-container">
        <CSSTransition
          classNames={`msg msg-animation`}
          in={info && !error && !verified}
          timeout={100}
          unmountOnExit
        >
          <div className="message-container">
            <Text
              class_name="message-help"
              text={info_message}
              theme={"help"}
              size="h7"
              font_style="italic"
            />
          </div>
        </CSSTransition>
        <CSSTransition
          classNames={`msg msg-animation`}
          in={error && !disabled}
          timeout={{ appear: 0, enter: 0, exit: 150 }}
          unmountOnExit
        >
          <div className="message-container">
            <Text
              class_name="message-error"
              text={error_message}
              theme={"fraudulent"}
              size="h7"
              font_style="italic"
            />
          </div>
        </CSSTransition>
        <CSSTransition
          classNames={`msg msg-animation`}
          in={verified && !disabled}
          timeout={{ appear: 0, enter: 0, exit: 150 }}
          unmountOnExit
        >
          <div className="message-container">
            <Text
              class_name="message-success"
              text={verified_message}
              theme={"success"}
              size="h7"
              font_style="italic"
            />
          </div>
        </CSSTransition>
      </div>
    </>
  );
};

export default FloatingInput2;

/* ---- SAMPLE Import -----

    <FloatingInput
        type={'text'}
        value={variable.value}
        info={variable.info}
        info_message={variable.infoMessage}
        error={variable.error}
        error_message={variable.errorMessage}
        verified={variable.verified}
        verified_message={variable.verifiedMessage}
        disabled={variable.disabled}
        label={'Enter variable'}
        left_label={'Rs.'}
        right_label={'/-'}
        on_change={handleOnChangeVariable}
        on_blur={handleOnBlurVariable}
    />

*/
